import { render, staticRenderFns } from "./index-ksupplys.vue?vue&type=template&id=5176e662&scoped=true"
import script from "./index-ksupplys.vue?vue&type=script&lang=js"
export * from "./index-ksupplys.vue?vue&type=script&lang=js"
import style0 from "./index-ksupplys.vue?vue&type=style&index=0&id=5176e662&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5176e662",
  null
  
)

export default component.exports